import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export interface RunnerResultCardProps {
  bib: string;
  grossTime: string;
  netTime: string;
}

export function RunnerResultCard({ bib, grossTime, netTime }: RunnerResultCardProps) {
  const theme = useTheme();
  const gradient = theme.custom?.gradient || theme.palette.primary.main;

  return (
    <Paper
      sx={{
        p: 2,
        position: 'relative',
        background: theme.palette.background.paper,
        border: 'none',
        borderRadius: 2,
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          padding: '2px',
          background: gradient,
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          pointerEvents: 'none',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary">
            ゼッケン
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700, fontFamily: 'monospace' }}>
            {bib}
          </Typography>
        </Box>
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary">
            グロス
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700, fontFamily: 'monospace' }}>
            {grossTime}
          </Typography>
        </Box>
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary">
            ネット
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700, fontFamily: 'monospace' }}>
            {netTime}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}
